import { state } from "../context/store";

const modeMethods = {
  multiribs: () => {
    // console.log("Setting multi ribs");
    state.current.choices.ribs.selected.mode = "multiple";
    state.current.modal.bottomAlign = true;
    state.current.modal.clearBackground = true;
    state.current.modal.open = true;
    state.current.modal.multiRib = true;
  },
  raceNumber: () => {
    // console.log("Setting race number");
    state.current.choices.raceNumber.selected.mode = "number";
    state.current.modal.bottomAlign = true;
    state.current.modal.clearBackground = true;
    state.current.modal.open = true;
    state.current.modal.settingNumber = true;
  },
  superBadge: () => {
    // console.log("Setting super badge");
    state.current.choices.superBadge.selected.mode = "badge";
    state.current.modal.bottomAlign = true;
    state.current.modal.clearBackground = true;
    state.current.modal.open = true;
    state.current.modal.superBadge = true;
  },
  reinforcedSides: () => {
    // console.log("Setting reinforcedSides");
    state.current.status.settingReinforcedSides = true;
    // state.current.choices.sidePanels.selected.mode = "reinforced";
    
  },
  regularSides: () => {
    // console.log("Setting reg Sides");
    state.current.status.settingReinforcedSides = false;
    // state.current.choices.sidePanels.selected.mode = "regular";

  },
};
export { modeMethods };
